$(function() {
  if ($("input").is(".js-field-dropdown-tickets__title_cost-checkout")) {
    $(".js-field-dropdown-tickets__title_cost-checkout").each(function() {
      $(this)
        .closest(".field-dropdown__wrap")
        .find(".field-dropdown-tickets__field")
        .each(function() {
          if (Number.parseInt($(this).val()) > 0) {
            const ticketsField = $(this)
              .closest(".js-field-dropdown__hidden")
              .siblings(".js-field-dropdown__label")
              .find(".js-field-dropdown__field_btn");
            const ticketsList = $(ticketsField).data("tickets")
              ? $(ticketsField).data("tickets")
              : { categories: {} };
            const $fieldName = $(this).attr("name");
            const $cost = $(this).data("cost");
            const $value = Number.parseFloat($(this).val());
            let comma = "";

            ticketsList["categories"][$fieldName];
            ticketsList["categories"][$fieldName] = [$value, $cost];
            ticketsList["ticketsCount"] = 0;
            ticketsList["totalCost"] = 0;
            ticketsList["toString"] = "";

            for (let ticket in ticketsList.categories) {
              ticketsList.toString +=
                comma + ticket + " x " + ticketsList["categories"][ticket][0];

              comma = ", ";

              ticketsList.ticketsCount++;

              ticketsList.totalCost +=
                ticketsList["categories"][ticket][0] *
                ticketsList["categories"][ticket][1];
            }

            $(ticketsField).data("tickets", ticketsList);
            $(ticketsField).val(ticketsList.toString);
          }
        });
    });

    $(".js-field-dropdown__label").on("click", function() {
      $(this).addClass("js-field-dropdown__label-for-availability");
    });
  }

  if ($(".js-field-dropdown-tickets__title_cost-checkout").data("tickets")) {
    $(".js-field-dropdown-tickets__title_cost-checkout")
      .closest(".js-field-dropdown__label")
      .addClass("has-value");
  }

  $(document).on("click", ".js-optional-travellers", function() {
    const isOpen = $(this).data("open");
    $(this).html(`<span class="fa ${isOpen ? "fa-plus-circle" : "fa-minus-circle"}"></span>&nbsp;<span>Add More Visitors/Travelers (Optional)</span>`);
    isOpen
      ? $(".js-optional-travellers-form").slideUp()
      : $(".js-optional-travellers-form").slideDown();
    $(this).data("open", !isOpen);
  });

  $('.view-seatmap-button').on('click', function() {
    //var id = $(this).data('id');
    //$("#seatmap-modal-" + id).fadeIn("easing");
    $(".js-seatmap-modal").fadeIn("easing");
  });

  $('.js-close-seatmap-modal-button, .js-close-window-seatmap-modal').on('click', function() {
    $(".js-seatmap-modal").fadeOut("easing");
  });
});



// WEBPACK FOOTER //
// ./resources/assets/js/components/checkout/form.js